import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';

// project imports
import Logo from 'ui-component/Logo';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
    // active menu item on page load
    <ButtonBase disableRipple component={Link} to="/index">
        <Logo />
    </ButtonBase>
);

export default LogoSection;
